const getBaseSearchQuery = (sku: string, routeQuery) => ({
  filter: {
    sku: {
      eq: sku
    },
  },
  configurations: Object.entries(routeQuery)
    .filter((config) => config[0] !== "wishlist")
    .map((config) => config[1]) as string[],
});

const getMultiSkuBaseSearchQuery = (skus: string[], routeQuery) => ({
  filter: {
    sku: {
      in: skus
    },
  },
  configurations: Object.entries(routeQuery)
    .filter((config) => config[0] !== "wishlist")
    .map((config) => config[1]) as string[],
});


export {getBaseSearchQuery, getMultiSkuBaseSearchQuery}